import React, { useState } from 'react'
import { Input, Modal, Form } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { userActions } from '../../../Redux/_actions'
import { keyConstants } from '../../../Redux/_reducers'
import { selectKeys } from '../../../Redux/selectors/selectors'
import { useComponentLocale } from '../../../hooks/useComponentLocale'
import styles from './AddKeyModal.module.scss'
import { HelpValidation } from './HelpValidation/HelpValidation'
import { SupportsContacts } from '../../../components/SupportContacts/SupportsContacts'
import methodsSrc from '../../../assets/paymentMethods.png'

function AddKeyModal() {
	const [form] = Form.useForm()
	const [keyText, setKeyText] = useState('')
	const [idDisabled, setIsDisabled] = useState(true)
	const { applyKeyRequest, applyKeyResponse, applyKeyVisible } = useSelector(selectKeys)
	const dispatch = useDispatch()

	const getLocale = useComponentLocale()
	const applyKeyLocale = getLocale({ component: 'add_key_modal', section: 'apply_key' })

	const onCloseModal = () => {
		dispatch({ type: keyConstants.APPLY_KEY_HIDE })
		form.resetFields()
		setKeyText('')
	}
	const onChangeInput = (e) => setKeyText(e.target.value)

	const applyLicenseKey = () => {
		dispatch(userActions.applyLicenseKey(keyText))
		setIsDisabled(true)
	}

	return (
		<Modal
			title={<span>{applyKeyLocale}</span>}
			okText={'Apply key'}
			centered
			open={applyKeyVisible}
			onCancel={onCloseModal}
			onOk={applyLicenseKey}
			className={styles.modalAddKeyWindow}
			width={645}
			okButtonProps={{
				disabled: !keyText || idDisabled,
				loading: applyKeyRequest,
				htmlType: 'submit',
			}}
		>
			<Form
				form={form}
				name='addKey'
				onFieldsChange={() => setIsDisabled(form.getFieldsError().some((field) => field.errors.length > 0))}
			>
				<div className={styles.modalBody}>
					<div className={styles.modalBodyItem}>
						<div className={styles.modalBodyText}>Your activation key:</div>
						<Form.Item
							name='key'
							rules={[
								{
									message: '',
									pattern:
										/^[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/,
								},
							]}
						>
							<Input
								value={keyText}
								placeholder='XXXX-XXXX-XXXX-XXXX-XXXX-XXXX'
								size='large'
								allowClear
								onChange={onChangeInput}
							/>
						</Form.Item>
					</div>
					<div className={styles.modalBodyItem}>
						<div className={styles.modalBodyText}>
							Activation by license key is alternative way to pay for GTOBase subscription. Please contact our support
							team to purchase subscription using huge variety of payment methods comfortable for you.
						</div>
						<div className={styles.supportsPart}>
							<SupportsContacts />
							<div className={styles.modalBodyText}>
								Supported payment methods:
								<img src={methodsSrc} alt={'Payment methods'} width={597} className={styles.paymentImg} />
							</div>
						</div>
					</div>
					<HelpValidation isError={keyText ? idDisabled : false} isApply={applyKeyResponse} keyText={keyText} />
				</div>
			</Form>
		</Modal>
	)
}

export default AddKeyModal
